import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'hideHeroScreenImage',
  initialState: null as boolean | null,
  reducers: {
    setHideHeroScreenImage(state, action: PayloadAction<boolean | null>) {
      return action.payload || null;
    },
  },
});

export const { setHideHeroScreenImage } = slice.actions;

export default slice.reducer;
